export default __webpack_public_path__ + "static/robust_labs-e1fbf59ed052097c2123b560a07c2c00.png";